export enum GemSpecies {
  Sapphire = 'Sapphire',
  Ruby = 'Ruby',
  Emerald = 'Emerald',
  Alexandrite = 'Alexandrite',
  Amethyst = 'Amethyst',
  Ametrine = 'Ametrine',
  Aquamarine = 'Aquamarine',
  Aventurine = 'Aventurine',
  Beryl = 'Beryl',
  CatsEye = "Cat's Eye",
  Chrysoberyl = 'Chrysoberyl',
  Citrine = 'Citrine',
  Coral = 'Coral',
  Garnet = 'Garnet',
  Indigolite = 'Indigolite',
  Iolite = 'Iolite',
  Jade = 'Jade',
  Kunzite = 'Kunzite',
  LapisLazuli = 'Lapis Lazuli',
  Malachite = 'Malachite',
  Moonstone = 'Moonstone',
  Morganite = 'Morganite',
  Onyx = 'Onyx',
  Opal = 'Opal',
  Pearl = 'Pearl',
  Peridot = 'Peridot',
  Quartz = 'Quartz',
  Rubellite = 'Rubellite',
  Spinel = 'Spinel',
  Tanzanite = 'Tanzanite',
  Topaz = 'Topaz',
  Tourmaline = 'Tourmaline',
  Tsavorite = 'Tsavorite',
  Turquoise = 'Turquoise',
  Vanadium = 'Vanadium',
  Zircon = 'Zircon',
  Grandidierite = 'Grandidierite',
  Sodalite = 'Sodalite',
  Apatite = 'Apatite',
  Sphene = 'Sphene',
  Heliodor = 'Heliodor',
  Prehnite = 'Prehnite',
  Spectrolite = 'Spectrolite',
  Other = 'Other',
}
